// extracted by mini-css-extract-plugin
module.exports = {"four-story-4s":"styles-m__four-story-4s__27o6S","title":"styles-m__title__2bM0h","story-card":"styles-m__story-card__3njR-","story-container":"styles-m__story-container__2djZF"};